// CARFIX AUTO — content + curated imagery
export const IMAGES = {
  heroCar:
    "https://images.pexels.com/photos/261985/pexels-photo-261985.jpeg",
  heroFloat:
    "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  repair:
    "https://images.pexels.com/photos/4116224/pexels-photo-4116224.jpeg",
  detailing:
    "https://images.pexels.com/photos/14231678/pexels-photo-14231678.jpeg",
  equipment:
    "https://images.pexels.com/photos/8478259/pexels-photo-8478259.jpeg",
  showcaseSilver:
    "https://images.pexels.com/photos/17185083/pexels-photo-17185083.jpeg",
  showcaseFoam:
    "https://images.pexels.com/photos/28995189/pexels-photo-28995189.jpeg",
};

export const SERVICES = [
  {
    id: "service",
    no: "01",
    title: "Precision Service",
    tag: "Scheduled Maintenance",
    desc: "Manufacturer-grade servicing calibrated on German diagnostic rigs. Fluids, filters, brakes and electronics — measured, not guessed.",
    image: IMAGES.equipment,
    points: ["Bosch ECU diagnostics", "OEM-spec fluids", "Digital health report"],
    span: "md:col-span-7",
  },
  {
    id: "repair",
    no: "02",
    title: "Mechanical Repair",
    tag: "Engine · Suspension · EV",
    desc: "From engine rebuilds to suspension geometry — repaired on Hunter alignment and torque-controlled tooling.",
    image: IMAGES.repair,
    points: ["Hunter 3D alignment", "Torque-calibrated tools", "EV-certified bays"],
    span: "md:col-span-5",
  },
  {
    id: "detailing",
    no: "03",
    title: "Wash & Detailing",
    tag: "Ceramic · Paint Correction",
    desc: "Touchless foam, pH-neutral chemistry and multi-stage paint correction finished with ceramic protection.",
    image: IMAGES.detailing,
    points: ["Touchless foam wash", "Paint correction", "9H ceramic coat"],
    span: "md:col-span-12",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "German engineering, Indian roads.",
    body: "Every bay runs on imported, factory-calibrated equipment. We bring Autobahn precision to the pothole and the monsoon.",
  },
  {
    no: "02",
    title: "Measured, never guessed.",
    body: "Diagnostics before decisions. Torque values, alignment angles and paint depth are logged — your car leaves with a data sheet.",
  },
  {
    no: "03",
    title: "One standard. Pan India.",
    body: "A CARFIX bay in Chennai delivers the identical protocol as one in Chandigarh. Same tools, same training, same finish.",
  },
];

export const STATS = [
  { value: "04", label: "Live Centres", suffix: "" },
  { value: "02", label: "Opening Soon", suffix: "" },
  { value: "250", label: "Target Network", suffix: "+" },
  { value: "100", label: "German-Equipped", suffix: "%" },
];

export const LOCATIONS_LIVE = [
  { city: "Faridkot", state: "Punjab" },
  { city: "Baghapurana", state: "Punjab" },
  { city: "Zirakpur", state: "Punjab" },
  { city: "Mansa", state: "Punjab" },
];

export const LOCATIONS_SOON = [
  { city: "Noida", state: "Uttar Pradesh" },
  { city: "Jammu & Kashmir", state: "J&K" },
];

export const CONTACT = {
  phones: ["+91 90737 00065", "+91 79868 69643"],
  whatsapp: "919073700065",
  email: "hello@carfixauto.in",
};
